import { Component, Input, Output, EventEmitter, OnInit, forwardRef } from '@angular/core';
import { NG_VALUE_ACCESSOR } from '@angular/forms';
import { CountrySelectVm } from 'src/app/view-model/country-select/country-select.vm';

declare const $: any;

@Component({
  selector: 'app-country-select',
  templateUrl: './country-select.component.html',
  styleUrls: ['./country-select.component.scss'],
  providers: [{
    provide: NG_VALUE_ACCESSOR,
    useExisting: forwardRef(() => CountrySelectComponent),
    multi: true,
  }],
})
export class CountrySelectComponent implements OnInit {
  @Input() placeholder = '';
  @Input() idPrefix;
  @Input() prefix;
  @Input() customClasses: string;
  @Input() dropdownStyles: string;
  @Output() selectedCountry = new EventEmitter<object>();
  @Input() isBanner: boolean;

  countries;
  country: any;
  isDisabled: boolean;
  onChange = (_: any) => { };
  onTouch = () => { };
  
  constructor(private vm: CountrySelectVm) {
  }

  getCountries() {
    this.vm.getCountries().subscribe((countries) => {
      this.countries = countries;
      this.country = this.countries[0];
      if (this.prefix) { this.countryInitial(this.prefix); }
    })
  }

  onInput(country: string) {
    this.country = country;
    this.onTouch();
    this.onChange(this.country);
  }

  countryInitial(prefix, r = false) {
    const country = this.countries.filter(ctry => ctry.prefix === Number(prefix))[0];
    this.country = country || this.countries[0];
  } 

  writeValue(country: any): void {
    this.country = country || '';
    if(!country.prefix){
      this.countryInitial(country, true);
    } 
  }

  registerOnChange(fn: any): void {
    this.onChange = fn;
  }

  registerOnTouched(fn: any): void {
    this.onTouch = fn;
  }

  setDisabledState?(isDisabled: boolean): void {
    this.isDisabled = isDisabled;
  }

  sendSelectedCountry(country) {
    this.country = country;
    this.selectedCountry.emit(this.country);
  }

  async ngOnInit() {
    await this.getCountries();
  }
}
